import classes from "./Analytics.module.scss";
import RedTitle from './../RedTitle/RedTitle';
import Item from "../Item/Item";

import target from "../../../Assets/Img/Src/target.png"
import targetWebp from "../../../Assets/Img/Webp/target.webp"

import kpi from "../../../Assets/Img/Src/kpi.jpg"
import kpiWebp from "../../../Assets/Img/Webp/kpi.webp"



const Analytics = ()=> {
  return (
    <div className={classes.Analytics}>
      <RedTitle 
        number={"02."}
        title={"Аналитика"}
        customClass={classes.Title}
        />
      <div className={classes.ScrollWrap}>
        <Item
          customWrapClass={classes.Item}
          number={"a."}
          title={"Для отслеживания\n поведения пользователей на сайте и поиска «узких мест»,"}
          text={"которые снижают конверсию, было создано 23 цели, за счет которых мы получили более подробные данные об эффективности работы различных элементов сайта."}
          customClass={classes.Cards}
          customTitleClass={classes.CardsTitle}
          src={target} srcWebp={targetWebp}
          customImgWrap={classes.Image}
        />
      </div>
      <div className={classes.ScrollWrap}>

      <Item
        customWrapClass={classes.Item}
        number={"b."}
        title={"Определение основных KPI и агрегация данных по ним."}
        text={<><span>Так как в своей работе мы не используем шаблонные отчеты, мы обсудили с Заказчиком формат и типы данных, которые были важны для бизнеса и создали таблицу, в которую вынесли основные KPI:</span> <span>Ежемесячно Заказчик получал отчет как по всем фактически проведенным работам, так и по всем отслеживаемым параметрам. Таким образом, наша работа и ее результаты были очень прозрачны.</span></>}
       
        customClass={classes.Cards}
        customTitleClass={classes.CardsTitle}

        src={kpi} srcWebp={kpiWebp}
        customImgWrap={classes.Image}
      />
      </div>
      <div className={classes.FewCards}>
        <Item
          customWrapClass={classes.customItem}
          number={"c."}
          title={"Мониторинг динамики переходов по всем отслеживаемым каналам."}
          text={"Кроме работ, проводимых нами в проекте, появились сторонние подрядчики по email-маркетингу, обновились подрядчики по контекстной рекламе. В рамках аналитической работы мы контролировали и предупреждали Заказчика обо всех аномалиях по всем рекламным каналам, создавая рекомендации на базе поканального анализа данных."}
        
          customClass={classes.OnlyCards}
          customTitleClass={classes.CardsTitle}
          customClassText={classes.CustomText}
        />
           <Item
        customWrapClass={classes.customItem}
        number={"d."}
        title={"Анализ динамики конкурентов для\n корректировки приложения усилий."}
        text={"Ежемесячный анализ динамики конкурентов позволял выявлять новые маркетинговые подходы, подмечать  нюансы, которые мы обсуждали с Заказчиком и на основе которых строили те или иные гипотезы, что позволяло разрабатывать новую, полезную для пользователей, функциональность на сайте."}
        
        customClass={classes.OnlyCards}
        customTitleClass={classes.CardsTitle}
        customClassText={classes.CustomText}


      />
      </div>
 

    </div>
  )
}

export default Analytics;